import { GrunndataAction } from './grunndata'
import {
  fetchFylkesresutater,
  FylkesresultatAction,
  resetFylkesresultater,
  reloadFylkesresutater
} from './fylkesresultat'
import {
  fetchKommuneresultat,
  KommuneresultatAction,
  resetKommuneresultat,
  reloadKommuneresultat
} from './kommuneresultat'
import { PageAction, setGeografi, setPage, setParti } from './page'
import { Geografi, isGeografi, isParti, Parti } from '../../domain'
import { AppThunkAction } from '..'

export type AppAction = PageAction | GrunndataAction | FylkesresultatAction | KommuneresultatAction

export function goToFylkesresultater(grunndata: Geografi) {
  return async (dispatch, getState) => {
    const current = getState().page.current
    if (isGeografi(current) && current.key === grunndata.key) {
      return null
    }

    await Promise.all([
      dispatch(setGeografi(grunndata)),
      dispatch(resetFylkesresultater()),
      dispatch(resetKommuneresultat())
    ])

    await dispatch(fetchFylkesresutater(getState().page.current))
  }
}

export function goToKommuneresultater(grunndata: Geografi) {
  return async (dispatch, getState) => {
    const current = getState().page.current
    if (isGeografi(current) && current.key === grunndata.key) {
      return null
    }

    await Promise.all([
      dispatch(setGeografi(grunndata)),
      dispatch(resetFylkesresultater()),
      dispatch(resetKommuneresultat())
    ])

    await dispatch(fetchKommuneresultat(getState().page.current))
  }
}

export function goToResultater(geografi: Geografi) {
  return async (dispatch, getState) => {
    const current = getState().page.current
    if (isGeografi(current) && current.key === geografi.key) {
      return null
    }
    await Promise.all([
      dispatch(setGeografi(geografi)),
      dispatch(resetFylkesresultater()),
      dispatch(resetKommuneresultat())
    ])

    await Promise.all([
      dispatch(fetchKommuneresultat(getState().page.current)),
      dispatch(fetchFylkesresutater(getState().page.current))
    ])
  }
}

export function goToParti(parti: Parti) {
  return async (dispatch, getState) => {
    const current = getState().page.current
    if (isParti(current) && current.id === parti.id) {
      return null
    }
    await Promise.all([
      dispatch(resetFylkesresultater()),
      dispatch(resetKommuneresultat()),
      dispatch(setParti(parti))
    ])
    const valg = getState().page.current.valg
    if (valg.length === 1 && valg[0].valgKey === '2019/fy') {
      /*
       * Dersom partiet kun stiller i fylkesvalget skal vi vise fylkesresultater med en gang.
       * Ellers skal kommuneresultatet vises
       * */
      await dispatch(fetchFylkesresutater(getState().page.current))
    } else {
      await dispatch(fetchKommuneresultat(getState().page.current))
    }
  }
}

export function reloadResultat(): AppThunkAction {
  return async (dispatch, getState) => {
    const { fylkesresultat, kommuneresultat } = getState()

    const promises: Promise<void>[] = []

    if (
      fylkesresultat.state === 'success' ||
      fylkesresultat.state === 'error' ||
      fylkesresultat.state === 'locked'
    ) {
      promises.push(dispatch(reloadFylkesresutater()))
    }

    if (
      kommuneresultat.state === 'success' ||
      kommuneresultat.state === 'error' ||
      kommuneresultat.state === 'locked'
    ) {
      promises.push(dispatch(reloadKommuneresultat()))
    }

    return Promise.all(promises)
  }
}

export function fetchDataForWidget(grunndata: Geografi | Parti, valgtype: 'kommune' | 'fylke') {
  return async (dispatch, getState) => {
    await dispatch(setPage(grunndata))
    if (valgtype === 'kommune') {
      await dispatch(fetchKommuneresultat(getState().page.current))
    } else {
      await dispatch(fetchFylkesresutater(getState().page.current))
    }
  }
}
